import axios from "axios";
import { Environment } from "../../types/shared.types";
import { AppConfig } from "../../types/videocall.types";

export const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const devApisBaseUrls = {
  consultation: 'https://dev-api.iknowly.com/api/v1/consultation',
};

export const prodApisBaseUrls = {
  consultation: 'https://prod-api.iknowly.com/api/v1/consultation',
};

export const baseApisUrls =
  process.env.REACT_APP_ENV === Environment.PROD
    ? prodApisBaseUrls
    : devApisBaseUrls;

const ConsultationAxios = axios.create({
  baseURL: baseApisUrls.consultation,
  headers: defaultHeaders,
});

export default ConsultationAxios;

export const APP_CONFIG: AppConfig = {
  appId: 130254091,
  serverSecret: process.env.REACT_APP_SERVER_SECRET || "21cfe3b91388d3b74f02986edbce0b06",
  baseUrl: process.env.REACT_APP_ENV === Environment.PROD ? "https://iknowly.com" : "https://dev.iknowly.com/"
} as const;